import Button from "@/components/Button";

interface NextButtonProps {
  onClick: () => void;
  disabled: boolean;
  isPending: boolean;
}

export default function NextButton(props: NextButtonProps) {
  return (
    <Button
      onClick={props.onClick}
      disabled={props.disabled}
      loading={props.isPending}
      text="Creating..."
    >
      Next
    </Button>
  );
}
